import apiClient from './api/client'
import type { LoginCredentials, RegisterData, AuthResponse, User } from '../types/auth'

export const authService = {
  async login(credentials: LoginCredentials): Promise<AuthResponse> {
    const { data } = await apiClient.post<AuthResponse>('/auth/login/', credentials)
    return data
  },

  async register(userData: RegisterData): Promise<AuthResponse> {
    // Transform camelCase to snake_case for backend
    const payload = {
      email: userData.email,
      password: userData.password,
      confirm_password: userData.confirmPassword,
      role: userData.role,
    }
    const { data } = await apiClient.post<AuthResponse>('/auth/register/', payload)
    return data
  },

  async logout(): Promise<void> {
    await apiClient.post('/auth/logout/')
  },

  async refreshToken(refreshToken: string): Promise<{ access: string; refresh: string }> {
    const { data } = await apiClient.post('/auth/refresh/', { refresh: refreshToken })
    return data
  },

  async verifyEmail(token: string): Promise<{ message: string }> {
    const { data } = await apiClient.post('/auth/verify-email/', { token })
    return data
  },

  async resendVerification(email: string): Promise<{ message: string }> {
    const { data } = await apiClient.post('/auth/resend-verification/', { email })
    return data
  },

  async getMe(): Promise<User> {
    const { data } = await apiClient.get<User>('/auth/me/')
    return data
  },

  async forgotPassword(email: string): Promise<{ message: string }> {
    const { data } = await apiClient.post('/auth/forgot-password/', { email })
    return data
  },

  async resetPassword(token: string, password: string): Promise<{ message: string }> {
    const { data } = await apiClient.post('/auth/reset-password/', { token, password })
    return data
  },

  async uploadProfilePicture(file: File): Promise<{ profile_picture_url: string | null }> {
    const formData = new FormData()
    formData.append('file', file)
    const { data } = await apiClient.post('/auth/profile-picture/', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    return data
  },

  async deleteProfilePicture(): Promise<{ profile_picture_url: string | null }> {
    const { data } = await apiClient.delete('/auth/profile-picture/')
    return data
  },
}

export default authService
